import Swal from 'sweetalert2';

const customSweet1button = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-secondary',
        input: 'form-control d-flex',
        popup: 'shadow'
    },
    buttonsStyling: false
});

const customSweet2buttons = Swal.mixin({
    customClass: {
        actions: 'w-100 d-flex justify-content-between px-6',
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-secondary',
        input: 'form-control d-flex',
        popup: 'shadow'
    },
    buttonsStyling: false,
});

const customSweet3buttons = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-secondary',
        input: 'form-control d-flex',
        popup: 'shadow',
        icon: 'border-0'
    },
    buttonsStyling: false
});

const loadingAlertbutton = Swal.mixin({
    customClass: {
        position: 'center',
        icon: 'success',
        title: 'Your work has been saved',
        showConfirmButton: false,
    },
});

export function parseMessage (a) {
    let message = "";
    for (let i in a) {
        if (a.hasOwnProperty(i)) {
            message += '<p style="line-height:normal; margin-bottom: 0;">' + a[i] + '</p>';
        }
    }
    return message;
}

export function showWarnings (m, functionPostAction = null) {
    customSweet1button.fire({
        html: parseMessage(m),
        icon: "warning",
    }).then((value) => {
        if (functionPostAction)
            functionPostAction();
    });
}

export function showWarningsAndClose (m, functionPostAction = null) {
    customSweet1button.fire({
        html: parseMessage(m),
        icon: "warning",
    }).then((result) => {
        if (functionPostAction)
            functionPostAction();
        if (result.isConfirmed) {
            window.close();
        }
    });
}

export function showSuccess (m = ['¡ La operación fue realizada !'], functionPostAction = null) {
    customSweet1button.fire({
        html: parseMessage(m),
        icon: "success",
    }).then((value) => {
        console.log(functionPostAction);
        if (functionPostAction)
            functionPostAction();
    });
}

export function showSuccess2 (title = "Éxito", m = ['¡ La operación fue realizada !'], functionPostAction = null) {
    customSweet1button.fire({
        title: title,
        html: parseMessage(m),
        icon: "success",
    }).then((value) => {
        console.log(functionPostAction);
        if (functionPostAction)
            functionPostAction();
    });
}

export function showSuccessAndClose (m = ['¡ La operación fue realizada !'], functionPostAction = null) {
    customSweet1button.fire({
        html: parseMessage(m),
        icon: "success",
    }).then((result) => {
        if (functionPostAction)
            functionPostAction();
        if (result.isConfirmed) {
            window.close();
        }
    });
}

export function showErrors (m = ['¡ La operación no pudo ser realizada !'], functionPostAction = null) {
    customSweet1button.fire({
        html: parseMessage(m),
        icon: "error",
    }).then((value) => {
        if (functionPostAction)
            functionPostAction();
    });
}

export function showErrors2 (title = "Error", m = ['¡ La operación no pudo ser realizada !'], functionPostAction = null) {
    customSweet1button.fire({
        title: title,
        html: parseMessage(m),
        icon: "error",
    }).then((value) => {
        if (functionPostAction)
            functionPostAction();
    });
}

export function showMessage (m, t = null, functionPostAction = null) {
    customSweet1button.fire({
        title: parseMessage(m),
        html: parseMessage(t),
    }).then((value) => {
        if (functionPostAction)
            functionPostAction();
    });
}


export function areYouSure (function_to_ok, title, text, confirmButtonText = 'SÍ', cancelButtonText = 'CANCELAR', width = null) {
    customSweet2buttons.fire({
        title: title,
        html: text,
        icon: "warning",
        width: width,
        showCancelButton: true,
        cancelButtonText: cancelButtonText,
        confirmButtonText: confirmButtonText,
        focusCancel: true
    })
        .then((result) => {
            if (result.isConfirmed) {
                function_to_ok();
            }
        });
}

export function areYouSureDelete (function_to_execute) {

    customSweet2buttons.fire({
        title: "¿Esta Seguro de eliminar?",
        text: "¡Una vez realizada la operación probablemente no se puedan recuperar los datos!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SÍ, ELIMÍNALO',
        reverseButtons: false,
        focusCancel: true
    })
        .then((result) => {
            if (result.isConfirmed) {
                function_to_execute();
            }
        });
}

export function sweetModalWithSelect (values, function_to_execute) {

    customSweet2buttons.fire({
        title: values.title == null ? '' : values.title,
        html: values.text == null ? '' : values.text,
        input: 'select',
        inputOptions: values.content == null ? '' : values.content,
        inputAttributes: {
            autocapitalize: 'off',
            style: 'max-width:70%; font-size: 1em;'
        },
        showCancelButton: true,
        cancelButtonText: values.buttonCancel == null ? 'VOLVER' : values.buttonCancel,
        confirmButtonText: values.buttonConfirm == null ? 'OK' : values.buttonConfirm,
        allowOutsideClick: false,
    })
        .then(result => {
            if (!result.isConfirmed) return null;
            function_to_execute(result.value)
                .then(() => { customSweet2buttons.close() })
                .catch(error => {
                    customSweet2buttons.close();
                    showErrors([error]);
                });

        })
}

export function loadingAlert (title) {
    loadingAlertbutton.fire({
        title: title ?? 'Cargando',
        html: '<div class="lds-facebook justify-self-center"><div></div><div></div><div></div></div>',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
    })
}

export function stopLoadingAlertVue () {
    if ($(".swal2-icon-show").length != 1) {
        loadingAlertbutton.close();
    }
}

export function stopLoadingAlert () {
    loadingAlertbutton.close();
}

export function showComingSoon (functionPostAction = null) {
    customSweet3buttons.fire({
        title: "¡Próximamente!",
        html: "Funcionalidad en construcción...",
        iconHtml: '<i class="fa-solid fa-gears border-0"></i>',
        iconColor: '#6c757d'
    }).then((value) => {
        if (functionPostAction)
            functionPostAction();
    });
}

export function validationAlert () {
    loadingAlertbutton.fire({
        title: 'Validando',
        html: '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
    })
}

export function stopValidationAlert () {
    loadingAlertbutton.close();
}

export function stopValidationAlertVue () {
    if ($(".swal2-icon-show").length != 1) {
        loadingAlertbutton.close();
    }
}

window.parseMessage = parseMessage;
window.showWarnings = showWarnings;
window.showWarningsAndClose = showWarningsAndClose;
window.showSuccess = showSuccess;
window.showSuccess2 = showSuccess2;
window.showSuccessAndClose = showSuccessAndClose;
window.showErrors = showErrors;
window.showErrors2 = showErrors2;
window.showMessage = showMessage;
window.areYouSure = areYouSure;
window.areYouSureDelete = areYouSureDelete;
window.sweetModalWithSelect = sweetModalWithSelect;
window.loadingAlert = loadingAlert;
window.stopLoadingAlert = stopLoadingAlert;
window.showComingSoon = showComingSoon;
